import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import BetaAccessGate from './BetaAccessGate';

function ProtectedRoute({ children }) {
  const [betaVerified, setBetaVerified] = useState(
    () => localStorage.getItem('betaAccessVerified') === 'true'
  );

  const isAuthenticated = () => {
    const token = localStorage.getItem('authToken');
    return !!token;
  };

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (!betaVerified) {
    return <BetaAccessGate onAccessGranted={() => setBetaVerified(true)} />;
  }

  return children;
}

export default ProtectedRoute;



